export default class Show {
  constructor() {
  }

  toggleSidebar(e) {
    e.preventDefault();

    $('body').toggleClass('article-sidebar-is-visible');

  }

  init() {
    $('.js-toggle-article-sidebar').on('click', this.toggleSidebar);
  }
}
